import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

import { FsMessage, MessageMode } from '@firestitch/message';
import { FsForcePasswordChange } from '@firestitch/password-reset';

import { SessionService, SigninService } from '@app/core';


@Injectable({
  providedIn: 'root',
})
export class LoggedInGuard  {

  private _router = inject(Router);
  private _sessionService = inject(SessionService);
  private _message = inject(FsMessage);
  private _signinService = inject(SigninService);
  private _forcePasswordChange = inject(FsForcePasswordChange);


  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    if (!this._signinService.signedIn()) {
      this._message.error('Your session has expired. Please signin again.',
        { mode: MessageMode.Toast });

      return this.createSigninUrlTree();
    }

    if (this._forcePasswordChange.requiresPasswordChange) {
      return this._forcePasswordChange.enforcePasswordChange(state.url);
    }

    return true;
  }

  public createSigninUrlTree(): UrlTree {
    const redirect = window.location.pathname + window.location.search;

    return this._router.createUrlTree(['/signin'],
      { queryParams: { redirect } });
  }

}
